import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom'

import Selector from '../Selector';

import Popular from './Popular';
import Discoveries from './Discoveries';
import Tags from './Tags';

import '../../../css/Explore.css';
import '../../../css/elementPage.css';

class Explore extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
    }
  }

  render() {

    let basePath = '/explore';

    let selectorElements = [
      {title: 'Popular', url: `${basePath}/popular`},
      {title: 'Discoveries', url: `${basePath}/discoveries`},
      {title: 'Tags', url: `${basePath}/tags`}  
    ];

    return (

      <div className="elementPage">

        <Selector elements={selectorElements}></Selector>

        <Switch>
          <Route path="/explore/popular" component={Popular}></Route>
          <Route path="/explore/discoveries" component={Discoveries}></Route>
          <Route path="/explore/tags" component={Tags}></Route>
          <Route render={ () => <Redirect to={`${basePath}/popular`}/> }></Route>
        </Switch>

      </div>

    );

    
  }

}

export default Explore;



// WEBPACK FOOTER //
// ./src/js/components/explore/Explore.jsx